import { IOrderRepository } from '../domain/repositories/IOrderRepository'
import { OrderSummaryEntity } from '../domain/entities/order.entity'

export class GetOrdersSummaryUseCase {
    private orderRepository: IOrderRepository

    constructor(orderRepository: IOrderRepository) {
        this.orderRepository = orderRepository
    }

    async execute(): Promise<OrderSummaryEntity> {
        return this.orderRepository.summary()
    }
}
